import { _ } from "../../../../core/polyglot/polyglot.js";
import AbstractReportTemplateSection from "./AbstractReportTemplateSection.js";

/**
 * Section used to render the condensed balance sheet of a period report.
 */
export default class BalanceSheetSection extends AbstractReportTemplateSection {
	getTitle() {
		return _("Balance sheet");
	}

	accept(visitor) {
		return visitor.visitBalanceSheetSection(this);
	}

	static getType() {
		return "BalanceSheetSection";
	}

	static getId() {
		return "balance-sheet";
	}

	static getReportId() {
		return "CondensedBalanceSheet";
	}
}
